import { ProductInformationSummaryLine } from 'Components/lines/product-information-summary-line/ProductInformationSummaryLine';
export default ProductInformationSummaryLine;
